import { jsx, jsxs } from "react/jsx-runtime";
import { Avatar, __css, MessageBar, MessageBarBody, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { initialsOf } from "../components/internal/initials.js";
import { brandTokens } from "../theme/themes.js";
import { layout } from "../theme/tokens.js";
const FSI = String.fromCharCode(8296);
const PDI = String.fromCharCode(8297);
const isolate = (text) => `${FSI}${text}${PDI}`;
const useStyles = __css({"bar":{"Bokbzmb":0,"Jyy4pa":0,"B1u1w3b":"fumxqvr","Bo78w4l":"fytpf60","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fjshy37","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"ft85np5","De3pzq":"fw3pusv","sj55zd":"f19n0e5","v9m1rr":0,"B5zvjvr":0,"i7wt9h":"fkjv9oa"},"body":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","i8kkvl":0,"Belr9w4":0,"rmohyg":"faqewft"}});
function ExternalSpaceBanner({ hostName, hostLogoUrl }) {
  const styles = useStyles();
  const { t } = useTranslation("ui");
  return /* @__PURE__ */ jsx(MessageBar, { intent: "info", layout: "auto", className: styles.bar, children: /* @__PURE__ */ jsxs(MessageBarBody, { className: styles.body, children: [
    /* @__PURE__ */ jsx(
      Avatar,
      {
        shape: "square",
        size: 20,
        name: hostName,
        initials: initialsOf(hostName),
        ...hostLogoUrl ? { image: { src: hostLogoUrl } } : {},
        "aria-hidden": true
      }
    ),
    /* @__PURE__ */ jsx("span", { children: t("shell.externalSpace", { host: isolate(hostName) }) })
  ] }) });
}
export {
  ExternalSpaceBanner,
  isolate
};
//# sourceMappingURL=external-space-banner.js.map

import "/opt/batiflow/app/packages/ui/dist/shell/external-space-banner.griffel.css";